import { Component, OnInit, NgZone } from '@angular/core';
import { MapService } from '@app/shared/services/map.service';
import { StationsService } from '@app/shared/services/stations.service';
import { VehiclesService } from '@app/shared/services/vehicles.service';
import { UsersService } from '@app/shared/services/users.service';
import { ReservationsService } from '@app/shared/services/reservations.service';
import { Router } from '@angular/router';

import * as moment from 'moment';

const FILTER_ALL = 0;
const FILTER_STATIONS = 1;
const FILTER_ALERTS = 2;

@Component({
  selector: 'app-multi-search',
  templateUrl: './multi-search.component.html',
  styleUrls: ['./multi-search.component.scss']
})
export class MultiSearchComponent implements OnInit {

  public today: string = moment().format();
  public filter: number = FILTER_ALL;
  public loading: boolean = true;

  public stations: Array<any> = [];
  public alerts: Array<any> = [];

  public vehicleSearch: string = '';
  public vehicleSelected: any = {};
  public vehicleOptions: any = [];
  public vehicleDisplay: boolean = false;
  public vehicleNoResult: boolean = true;
  public vehicleLoading: boolean = false;

  public searchLoading: boolean = false;

  public stationLoading: boolean = false;
  public stationNoResult: boolean = true;
  public stationsOptions: any = [];

  public userLoading: boolean = false;
  public userNoResult: boolean = true;
  public usersOptions: any = [];

  public reservationLoading: boolean = false;
  public reservationNoResult: boolean = true;
  public reservationsOptions: any = [];


  public _timeout: any = null;

  constructor(
    private stationService: StationsService,
    private router: Router,
    private vehicleService: VehiclesService,
    private usersService: UsersService,
    private reservationsService: ReservationsService,
    private mapService: MapService,
    private lc: NgZone
  ) { }

  changeFilter(filter): void {
    if (this.filter === filter) {
      return;
    }
    this.loading = true;
    switch (filter) {
      case FILTER_ALERTS:
        this.remove('station');
        if (this.filter === FILTER_ALL)
          break;
        this.addAlertMarkers();
        break;
      case FILTER_STATIONS:
        this.remove('alert');
        if (this.filter === FILTER_ALL)
          break;
        this.addStationMarkers();
        break;
      case FILTER_ALL:
        if (this.filter === FILTER_STATIONS)
          this.addAlertMarkers();
        if (this.filter === FILTER_ALERTS)
          this.addStationMarkers();
        break;
    }
    this.filter = filter;
    this.loading = false;
  }

  getStations(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.stationService.getStations().then((stations) => {
        this.stations = stations;
        resolve(stations);
      });
    });
  }

  addStationMarkers(): void {
    this.stations.map((station) => {
      var marker = this.mapService.addMarker([station.latitude, station.longitude], { type: "station" });

      marker.bindPopup(`<span class="title">${station.name}</span>`);
      return station;
    });
  }

  getAlerts(): Promise<any> {
    return new Promise((resolve, reject) => {
      this.alerts = [];
      resolve([]);
    });
  }

  addAlertMarkers(): void {

  }

  addVehicleMarker(): void {
    var marker = this.mapService.addMarker(
      [this.vehicleSelected.latitude, this.vehicleSelected.longitude],
      { icon: "vehicle", type: "vehicle" }
    );

    marker.setZIndexOffset(1000);
    marker.bindPopup(`<span class="title">${this.vehicleSelected.name}</span>`);
  }

  remove(type): void {
    this.mapService.markers.map((marker) => {
      if (marker.options.type === type) {
        this.mapService.removeMarker(marker._leaflet_id);
      }
    });
  }

  ngOnInit(): void { }

  searchManager(event) {
    if (this._timeout) {
      window.clearTimeout(this._timeout);
    }
    this._timeout = window.setTimeout(() => {
      this._timeout = null;
      this.lc.run(() => {
        this.updateVehicleList(event);
        this.updateStationList(event);
        this.updateUserList(event);
        this.updateReservationList(event);
      });
    }, 1000);
  }

  updateVehicleList(event) {
    console.log("updateVehicleList", event)
    this.vehicleSearch = event;
    this.vehicleLoading = true;
    this.vehicleNoResult = false;

    this.vehicleService.updateVehicles(1, this.vehicleSearch).then((res) => {
      console.log("vehicles", res);
      if (res.length > 0) {
        this.vehicleOptions = res;
      } else {
        this.vehicleNoResult = true;
      }
      this.vehicleLoading = false;
    });
  }

  updateStationList(event) {
    this.stationLoading = true;
    this.stationNoResult = false;

    this.stationService.updateStations(1, event).then((res) => {
      if (res.length > 0) {
        console.log(res);
        this.stationsOptions = res;
      } else {
        this.stationNoResult = true;
      }
      this.stationLoading = false;
    });
  }

  updateReservationList(event) {
    this.reservationLoading = true;
    this.reservationNoResult = false;

    let dateMin = moment().subtract(6, 'months').format('YYYY-MM-DD');
    let dateMax = moment().add(6, 'months').format('YYYY-MM-DD');

    console.log(dateMin, dateMax);

    this.reservationsService.updateReservationByDate(dateMin, dateMax, 1, 0, event, "").then((res) => {
      console.log(res)
      if (res.length > 0) {
        this.reservationsOptions = res;
      } else {
        this.reservationNoResult = true;
      }
      this.reservationLoading = false;
    });
  }

  updateUserList(event) {
    this.userLoading = true;
    this.userNoResult = false;

    this.usersService.updateUsers(1, event).then((res) => {
      console.log(res)
      if (res.length > 0) {
        this.usersOptions = res;
      } else {
        this.userNoResult = true;
      }
      this.userLoading = false;
    });
  }


  // updateVehicleOptionList(event) {
  //   if (this._timeout) {
  //     window.clearTimeout(this._timeout);
  //   }
  //   this._timeout = window.setTimeout(() => {
  //     this._timeout = null;
  //     this.lc.run(() => {
  //       this.vehicleSearch = event;
  //       this.vehicleLoading = true;
  //       this.vehicleNoResult = false;
  //       this.vehicleService.updateVehicles(1, this.vehicleSearch).then((res) => {
  //         if (res.length > 0) {
  //           this.vehicleOptions = res;
  //         } else {
  //           this.vehicleNoResult = true;
  //         }
  //         this.vehicleLoading = false;
  //       });
  //     });
  //   }, 1000);
  // }

  setVehicleSearch(option) {
    this.vehicleSearch = option.name;
    this.vehicleSelected = option;
    this.remove('vehicle');
    this.addVehicleMarker();
    this.mapService.flyTo({
      latitude: this.vehicleSelected.latitude,
      longitude: this.vehicleSelected.longitude,
      zoom: 15
    })
  }

  // setReservationSearch(option) {
  //   this.vehicleSearch = option.Code;
  //   this.reservationSelected = option;
  //   this.remove('reservation');
  //   this.addReservationMarker();
  //   this.mapService.flyTo({
  //     latitude: this.reservationSelected.latitude,
  //     longitude: this.reservationSelected.longitude,
  //     zoom: 15
  //   })
  // }

  toggleSuggestions(shouldDisplay) {
    setTimeout(() => {
      this.vehicleDisplay = shouldDisplay;
    }, 250);
  }

  goToVehicule(option) {
    this.router.navigate([`ressource/station/list/`]).then(() => {
      this.router.navigate([`ressource/vehicle/informations/${option.id}`]);
    });
  }

  goToStation(option) {
    console.log(option);
    this.router.navigate([`ressource/station/list/`]).then(() => {
      this.router.navigate([`ressource/station/informations/${option.id}`]);
    });
  }

  goToUser(option) {
    console.log("USER ", option);
    this.router.navigate([`user/list/`]).then(() => {
      this.router.navigate([`user/informations/${option.AccountId}`]);
    });
  }

  goToReservation(option) {
    console.log(option);
    this.router.navigate([`reservation/list/`]).then(() => {
      this.router.navigate([`reservation/informations/${option.Id}`]);
    });
  }
}
